// extracted by mini-css-extract-plugin
export default {"windowWrapper":"render_windowWrapper__kUZlU","genericElement":"render_genericElement__9MKKQ"};